module.exports = __webpack_public_path__ + "static/media/Cookies.78930478.jpg";